import type { QuestionConfig } from "../types/questionnaire";

export const QUESTIONS: QuestionConfig[] = [
	{
		id: "current_symptoms",
		type: "text",
		i18nKey: "questions.currentSymptoms",
	},
	{
		id: "known_allergies",
		type: "multiselect",
		i18nKey: "questions.knownAllergies",
		options: [
			"questions.knownAllergies.options.pollen",
			"questions.knownAllergies.options.dust",
			"questions.knownAllergies.options.peanuts",
			"questions.knownAllergies.options.penicillin",
			"questions.knownAllergies.options.aspirin",
			"questions.knownAllergies.options.none",
		],
	},
	{
		id: "energy_levels",
		type: "radio",
		i18nKey: "questions.energyLevels",
		options: [
			"questions.energyLevels.options.low",
			"questions.energyLevels.options.moderate",
			"questions.energyLevels.options.high",
		],
	},
	{
		id: "medical_documents",
		type: "file_upload",
		i18nKey: "questions.medicalDocuments",
	},
];
